import type { RtdbClient } from '@akpl/firebase/client';

import { getFirebase } from '../firebase';
import { useStore } from '../store';
import { createFakeLive, type FakeLive } from './fakeFeed';

let fake: FakeLive | null = null;
let override: RtdbClient | null = null;

/**
 * The RTDB handle every live hook goes through (docs/04 §1). With a Firebase project this is
 * the SDK client loaded at boot; in offline-auth mode it is the in-memory fake feed so the
 * screens still render in browser dev. `null` means "no live data yet" (booting, or Firebase
 * failed to load): callers subscribe to nothing and stay on the last store state.
 */
export function getLiveClient(): RtdbClient | null {
  if (override) return override;
  const firebase = getFirebase();
  if (firebase) return firebase;
  if (useStore.getState().authMode !== 'offline') return null;
  if (!fake) {
    fake = createFakeLive();
    // Dev affordance: `window.__akpLive.emit('/sessions/x/meta', { …, status: 'closed' })`
    // drives the offline feed from the console (session end, a new queue item, …).
    if (import.meta.env.DEV) (globalThis as { __akpLive?: FakeLive }).__akpLive = fake;
  }
  return fake;
}

/** The offline fake feed, when it is the active client (dev overlay, tests). */
export function getFakeLive(): FakeLive | null {
  return override ? null : (fake ?? null);
}

/** Test seam: forces the client returned by `getLiveClient()`. */
export function setLiveClientForTests(client: RtdbClient | null): void {
  override = client;
  fake = null;
}
